/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { currentDashboardViews } from '@stores/dashboardViewPageSlice';
import { getUtcToLocal } from '@awp/helpers/utilsReact';
import Table, { MAX_PAGE_SIZE } from '@awp/components/table';
import SensorStateRectangles from '@awp/components/dashboards/GraphView/SensorStateRectangles';
import { STATE_STATUS } from '@awp/constants';

const TimeBasedTable = ({ isMedium }) => {
  const loading = useSelector((state) => state.dashboardViewPage.status);
  const dashboardViewPage = useSelector(currentDashboardViews);
  const [tableDates, setTableDates] = useState([]);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (!dashboardViewPage) return;
    const timeBasedStats = dashboardViewPage?.TimeBasedStats;
    reorganizeWeatherData(timeBasedStats);
  }, [dashboardViewPage]);

  const setHeader = () => {
    const result = tableDates.map((x) => {
      return {
        Header: x,
        accessor: x,
        disableSortBy: true,
        style: { padding: '0px', borderRight: '2px solid #0D0D0D', borderBottom: '1px solid #0D0D0D' },
        Cell: (c) => {
          const weatherStationIndex = c.data.findIndex(
            (item) => c.row.original.WeatherStationId == item.WeatherStationId,
          );
          if (weatherStationIndex != -1) {
            const wsColors = c.data[weatherStationIndex].data.filter(
              (item) => item.CollectionTimeLocal.split(' ')[0] == c.column.Header,
            );
            return (
              <div
                style={{
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                  width: '100%',
                  display: 'flex',
                  backgroundColor: '#0D0D0D',
                }}
              >
                {wsColors.reverse().map((ws, index) => (
                  <SensorStateRectangles
                    key={index}
                    data={ws}
                    index={index}
                    isMedium={isMedium}
                    WeatherStationName={c?.data[weatherStationIndex]?.WeatherStationName}
                  />
                ))}
              </div>
            );
          }
        },
      };
    });
    result.unshift({
      Header: 'Name',
      accessor: 'Weather Station',
      disableSortBy: true,
      style: { padding: '0px', fontSize: '0.8rem' },
      Cell: (c) => {
        return (
          <div
            style={{
              overflow: 'hidden',
              maxWidth: '258ch',
              flexWrap: 'nowrap',
              alignItems: 'center',
              display: 'flex',
              whiteSpace: 'nowrap',
              borderBottom: '1px solid #efefef',
            }}
          >
            {isMedium && c.row.original.WeatherStationNumber + ' - ' + c.row.original.WeatherStationName}
            {!isMedium && c.row.original.WeatherStationNumber}
          </div>
        );
      },
    });
    return result;
  };

  const columns = React.useMemo(() => setHeader());
  const reorganizeWeatherData = (data) => {
    const result = [];
    const uniqueDates = new Set();
    data.forEach((entry) => {
      const { WeatherStationId, WeatherStationName, WeatherStationNumber, CollectionTime, Color } = entry;

      let station = result.find((item) => item.WeatherStationId === WeatherStationId);

      if (!station) {
        station = {
          WeatherStationId,
          WeatherStationName,
          WeatherStationNumber,
          data: [],
        };
        result.push(station);
      }

      const CollectionTimeLocal = getUtcToLocal(CollectionTime);
      const date = CollectionTimeLocal.split(' ')[0];
      uniqueDates.add(date);
      station.data.push({
        CollectionTimeLocal,
        Color,
      });
    });

    setTableData(result);
    setTableDates(Array.from(uniqueDates).reverse());
  };

  return (
    <div className="timebased-table timebased-table-override">
      {
        <Table
          loading={loading == STATE_STATUS.LOADING}
          columns={columns}
          data={tableData}
          isFirstColumnSticky={true}
          showPagination={true}
          maxHeight={'max-content'}
          customClass={'simplebar-custom'}
          fetchData={() => {}}
          defaultPageSize={MAX_PAGE_SIZE}
        />
      }
    </div>
  );
};

TimeBasedTable.propTypes = {};

export default TimeBasedTable;
